import styles from './InfoBox.module.scss'

export const defaultByline = 'key information' as const

export const infoBoxStyles = {
  red: {
    colourClass: styles.infoBoxWrapperRed,
    defaultByline: 'warning',
  },
  yellow: {
    colourClass: styles.infoBoxWrapperYellow,
    defaultByline: 'caution',
  },
  green: {
    colourClass: styles.infoBoxWrapperGreen,
    defaultByline,
  },
  blue: {
    colourClass: styles.infoBoxWrapperBlue,
    defaultByline,
  },
  unstyled: {
    colourClass: styles.infoBoxWrapperBlack,
    defaultByline,
  },
} as const

export type InfoBoxBorderColours = Exclude<keyof typeof infoBoxStyles, 'unstyled'>
